<template lang="html">
  <div class="invite">
    <div class="informerBtn" @click="informerShow = 1">
      <p>一键举报</p>
    </div>

    <img :src="`${pagebase}/static/img/assistance/backInvite.png`" alt="" class="backInvite">
    <div class="inviteCon">
      <div class="swiper-container swiperCon swiper-no-swiping" v-show="helpingList.length">
        <div class="swiper-wrapper">
          <div class="swiper-slide swiperSlide" v-for="(a, index) in helpingList" :key="index">
            <div class="friendPhone">
              <p>助力好友</p>
              <p class="phone">{{a.phone.slice(0,3) + '****' + a.phone.slice(7,12)}}</p>
            </div>
            <div>{{ a.create_time }}</div>
          </div>
        </div>
      </div>

      <div class="noPeople" v-show="helpingList.length == 0">
        好惨哦，没有一个助力呢，快去邀请吧
      </div>
      
      <div class="honoree" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/phone.png` +')'}">
        <p>领取奖励者：</p>
        <span>{{honoree}}</span>
      </div>

      <div class="wealNo1" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/prize_1.png` +')'}">
        <div class="wealNum">
          <div class="helpingNum">
            已有{{helpingList.length}}人助力
          </div>
          <img :src="`${pagebase}/static/img/assistance/icon6.png`" alt="">
          <div class="residueNum">
            <p>还差</p>
            <p class="people" v-if="1 - helpingList.length > 0">{{1- helpingList.length}}</p>
            <p class="people" v-else>{{0}}</p>
            <p>人</p>
          </div>
        </div>

        <div class="wealCard">
          <div class="wealCon1">
            <img :src="`${pagebase}/static/img/assistance/gift1.png`" alt="">
            <div>
              <p>电路图设计实例合集</p>
              <p>300+典型电路图详解大咖设计经验亲授</p>
            </div>
          </div>
          <div class="wealCon2">
            <div>
              <p>83类国产芯片替代公司名单</p>
              <p>移动CPU、IP、GPU、DSP、FPGA…</p>
            </div>
            <img :src="`${pagebase}/static/img/assistance/gift2.png`" alt="">
          </div>
          <div class="wealCon1">
            <img :src="`${pagebase}/static/img/assistance/gift3.png`" alt="">
            <div>
              <p>半导体材料&设备最新技术资料</p>
              <p>单晶炉、第三代半导体材料、光刻机…</p>
            </div>
          </div>
          <div class="wealCon2">
            <div>
              <p>100余份大厂硬件及IC笔试模拟题</p>
              <p>华为、中兴、联发科、小米…</p>
            </div>
            <img :src="`${pagebase}/static/img/assistance/gift4.png`" alt="">
          </div>
        </div>

        <div class="receiveAward" v-if="prize1">
          <div>已领取</div>
        </div>
        <div class="wealBtn" @click.capture="getShowStat(2)" v-else>
          <div v-if="1 - helpingList.length > 0">
            前往APP去分享
            <WxOpenTag ref="wxopentag" :extinfo="'native/current'" />
          </div>
          <div v-else @click="emailShow = true, wealNum = 1">去领取</div>
        </div>
      </div>

      <div class="wealNo2" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/prize_2.png` +')'}">
        <div class="wealNum">
          <div class="helpingNum">
            已助力{{helpingList.length}}人
          </div>
          <img :src="`${pagebase}/static/img/assistance/icon6.png`" alt="">
          <div class="residueNum">
            <p>还差</p>
            <p class="people" v-if="3 - helpingList.length > 0">{{3 - helpingList.length}}</p>
            <p class="people" v-else>{{0}}</p>
            <p>人</p>
          </div>
        </div>

        <div class="wealCard">
          <div class="wealCon1">
            <img :src="`${pagebase}/static/img/assistance/gift5.png`" alt="">
            <div>
              <p>大厂内部接口规范/华为硬件设计规范</p>
              <p>电子元器件选型规范、逻辑电平接口设计规范…</p>
            </div>
          </div>
          <div class="wealCon2">
            <div>
              <p>硬件工程师必读电子书20本</p>
              <p>涉及电源设计、半导体、信号、射频…</p>
            </div>
            <img :src="`${pagebase}/static/img/assistance/gift6.png`" alt="">
          </div>
          <div class="wealCon1">
            <img :src="`${pagebase}/static/img/assistance/gift7.png`" alt="">
            <div>
              <p>30份半导体行业研究报告合集</p>
              <p>电池管理、功率半导体、光芯片…</p>
            </div>
          </div>
          <div class="wealCon2">
            <div>
              <p>电子人效率工具合集</p>
              <p>电路计算Excel合集，BGA管脚信号自动上色程序、EDA软件互转工具</p>
            </div>
            <img :src="`${pagebase}/static/img/assistance/gift8.png`" alt="">
          </div>
        </div>

        <div class="receiveAward" v-if="prize2">
          <div>已领取</div>
        </div>
        <div class="wealBtn" @click.capture="getShowStat(2)" v-else>
          <div v-if="3 - helpingList.length > 0">
            前往APP去分享
            <WxOpenTag ref="wxopentag" :extinfo="'native/current'" />
          </div>
          <div v-else @click="emailShow = true, wealNum = 2">去领取</div>
        </div>
      </div>

      <div class="wealNo3" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/prize_3.png` +')'}">
        <div class="wealNum">
          <div class="helpingNum">
            已助力{{helpingList.length}}人
          </div>
          <img :src="`${pagebase}/static/img/assistance/icon6.png`" alt="">
          <div class="residueNum">
            <p>还差</p>
            <p class="people" v-if="5 - helpingList.length > 0">{{5 - helpingList.length}}</p>
            <p class="people" v-else>{{0}}</p>
            <p>人</p>
          </div>
        </div>
        
        <div class="wealConCalendar">
          <div>免费领大咖推荐书籍购书金<span>（30元京东e卡）</span></div>
          <img :src="`${pagebase}/static/img/assistance/gift9.png`" alt="">
          
        </div>

        <div class="wealConPlacemat">
          <div>超大半导体产业链技术图谱桌垫<span>（包邮）</span></div>
          <img :src="`${pagebase}/static/img/assistance/gift10.png`" alt="">
        </div>

        <div class="receiveAward site" v-if="prize3">
          <div>查看领取进度</div>
          <WxOpenTag ref="wxopentag" :extinfo="'webView/detail?url=' + apppagebase + '/ordersDetails?hideNativeNav=1&sn=' + order"/>
        </div>
        <div class="wealBtn" @click.capture="getShowStat(2)" v-else>
          <div v-if="5 - helpingList.length > 0">
            前往APP去分享
            <WxOpenTag ref="wxopentag" :extinfo="'native/current'" />
          </div>
          <div v-else @click="locationShow = true, wealNum = 3">去领取</div>
        </div>
      </div>

      <img :src="`${pagebase}/static/img/assistance/book.png`" alt="" class="inviteImg">
      <img :src="`${pagebase}/static/img/assistance/invite.png`" alt="" class="inviteImg">

      <div class="conBtn">
        <div class="liveStreamingBtn" v-if="activityType" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/button1.png` +')'}" @click.capture="getShowStat(1)">
          云上观展

          <WxOpenTag ref="wxopentag" :extinfo="'live/detail?url=' + activityUrl" />
        </div>
        
        <div class="liveStreamingBtn" @click="addGroupShow = 1, getShowStat(4)" v-else :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/button_1.png` +')'}">
          芯片国产化<br>交流群
        </div>
        
        <div class="giftBtn" @click.capture="getShowStat(2)" :class="{giftBtnType: giftType}" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/button_2.png` +')'}" >
          <img :src="`${pagebase}/static/img/assistance/icon.png`" alt="">
          前往APP领实物
          <WxOpenTag ref="wxopentag" :extinfo="'native/current'" />
        </div>
      </div>
    </div>
    
    <div class="addGroupHint" v-show="addGroupShow == 1" @click="addGroupShow = 0">
      <div class="groupCon">
        <div>扫码进群</div>
        <img :src="`${pagebase}/static/img/assistance/qrCode.png`" alt="">
        <p>半导体&硬件&PCB&射频等多行业大咖交流群</p>
        <p>进群享受电子人共享通讯录</p>
        <p>与大咖资源共享</p>
      </div>
    </div>

    <!-- 填邮箱 -->
    <div class="emailCard" v-show="emailShow" @click.self="emailShow = false">
      <div class="emailCon" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/hint2.png` +')'}">
        <input type="email" class="emailInput" placeholder="写输入您接收资料的邮箱" name="emailInput" v-model="email">

        <div class="confirmBtn" @click.stop="confirmEmail">
          确定
        </div>
      </div>
    </div>
    
    <div class="emailSucceed" v-show="emailSucceedShow" @click.self="emailSucceedShow = false">
      <div class="emailSucceedCon" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/hint2.png` +')'}">
        <p class="emailSucceedTxt">已使用电巢【EDA365】邮箱成功发送<br>请及时查收</p>
        <p class="closeEmailSucceedBtn" @click.stop="emailSucceedShow = false">我知道了</p>
      </div>
    </div>

    <!-- 填地址 -->
    <div class="locationCard" v-show="locationShow" @click.self="locationShow = false">
      <div class="locationCon" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/hint1.png` +')'}">
        <div class="locationTxt">
          <p>请输入您详细的收货地址</p>
          <input placeholder="收件人姓名" name="userName" type="text" class="userName" v-model='userName'>
          <input placeholder="收件人电话" name="userPhone" type="text" class="userPhone" v-model='userPhone'>
          <textarea placeholder="详细地址" name="userLocation" class="userLocation" v-model='location'/>
        </div>

        <div class="confirmBtn" @click.stop="confirmLocation">
          确定
        </div>
      </div>
    </div>
    
    <div class="locationSucceed" v-show="locationSucceedShow" @click.self="locationSucceedShow = false">
      <div class="locationSucceedCon" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/hint2.png` +')'}">
        <p class="locationSucceedTitle">提交成功</p>
        <p class="locationSucceedTxt">在「电巢APP」上查看订单进度<br>前往APP查看</p>
        <div class="locationSucceedBtn">
          <p class="closeSucceedBtn" @click.stop="locationSucceedShow = false">我知道了</p>
          <p class="openAppBtn" @click.capture="locationSucceedShow = false, getShowStat(5)">
            <span>去电巢app</span>
            <WxOpenTag ref="wxopentag" :extinfo="'webView/detail?url=' + apppagebase + '/ordersDetails?hideNativeNav=1&sn=' + order"/>
          </p>
        </div>
      </div>
    </div>

    <div class="informerHint" v-show="informerShow == 1" @click.self="informerShow = 0">
      <div class="informerCon">
        <p class="informerInfo">已收到您的反馈，客服会尽快<br>与您取得联系</p>
        <p class="informerClose" @click="informerShow = 0">我知道了</p>
      </div>
    </div>
    
    <div class="callApp" @click.capture="getShowStat(3)">
      <img :src="`${pagebase}/static/img/assistance/callapp.png`" alt="">
      <WxOpenTag ref="wxopentag" :extinfo="'native/current'" />
    </div>
  </div>
</template>

<script>
  import {
    pagebase,
    apppagebase
  } from '@/utils/http.js';
  import Swiper from 'swiper/swiper-bundle.min.js'
  import 'swiper/swiper-bundle.min.css'

  import utils from '@/utils/utils.js';
  import '@/utils/rem'
  import Cookies from 'js-cookie';
  import WxOpenTag from '@/components/WxOpenTag'
  import WxShare from '@/utils/wxshare'

  export default {
    data() {
      return {
        pagebase: pagebase,
        apppagebase: apppagebase,
        helpingList: [],
        emailShow: false,
        emailSucceedShow: false,
        email: '',
        locationShow: false,
        locationSucceedShow: false,
        userName: '',
        userPhone: '',
        location: '',
        wealNum: 0,
        activityUrl: '',
        informerShow: 0,
        honoree: '',
        activityType: this.$route.query.type || '',
        addGroupShow: 0,
        giftType: false,
        order: '',
        
        prize1:0,
        prize2:0,
        prize3:0,
      }
    },

    components: {
      WxOpenTag: WxOpenTag,
    },

    mounted() {
      document.title = '电巢读书月 专家荐好书';
      this.getShowStat(0);
      this.getGiftType();
      // 注册打开app组件
      if(utils.browserChecker.isWx()){
        this.$refs.wxopentag.register()
      }
      
      this.honoree = Cookies.get('phone');
      this.getHelpingList();
      this.gitActivityInfo();
      
      this.getLiveUrl();
      this.getOrder();
      
      new WxShare().share({
        title: '快来一起免费领半导体行业桌垫/京东E卡购书金吧！',
        desc: '和HW工程师解封绝密技术资料！',
        link: 'http://app.eda365.com:8088/pages/m/#/assistance?aid=' + Cookies.get('aid') + '&activityId=' + this.$route.query.activityId,
        imgUrl: pagebase + '/static/img/assistance/breviaryImg.png'
      });
    },

    methods: {
      getShowStat(id) {
        this.$http.get('/api/showStat', {
          params: {
            url: window.location.href,
            type: id,
          }
        })
      },
      
      getGiftType(){
        setInterval(() => {
          this.giftType = true;
        },500)
        setInterval(() => {
          this.giftType = false;
        },1000)
      },
      
      getOneSwiper() {
        new Swiper(".swiper-container", {
          autoplay: true,
          delay: 1000,
          loop: true,
          direction: "vertical",
          noSwiping: true,
        });
      },

      gitActivityInfo() {
        this.$http({
          url: '/member/activityInfo',
          method: 'get',
          params: {
            uid: Cookies.get('uid'),
            token: Cookies.get('token'),
            reg_channel: Cookies.get('reg_channel'),
            activity_reg_id: Cookies.get('aid'),
            type: 0,
            live_activity_id: this.$route.query.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.prize1 = res.data.gift[0].is_get;
            this.prize2 = res.data.gift[1].is_get;
            this.prize3 = res.data.gift[2].is_get;
            this.getOneSwiper();
          }
        })
      },

      // 助力列表
      getHelpingList() {
        this.$http({
          url: '/member/getHelpingList',
          method: 'get',
          params: {
            activity_reg_id: Cookies.get('aid'),
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.helpingList = res.data;
          }
        })
      },

      // 跳转直播间
      getLiveUrl() {
        this.$http({
          url: '/activity/detail',
          method: 'get',
          params: {
            activity_id: this.$route.query.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityUrl = res.data.live_url;
            if (Cookies.get('uid') && Cookies.get('token')) {
              this.getInfo = true;
            } else {
              this.getInfo = false;
            }
          }
        })
      },

      // 确认邮箱
      confirmEmail() {
        const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if (mailReg.test(this.email)) {
          this.$http({
            url: '/member/getNewPrize',
            method: 'post',
            params: {
              uid: Cookies.get('uid'),
              token: Cookies.get('token'),
              reg_channel: Cookies.get('reg_channel'),
              activity_reg_id: Cookies.get('aid'),
              type: this.wealNum,
              address: this.email,
              live_activity_id: this.$route.query.activityId,
              is_real: 0,
            },
          }).then((res) => {
            if (res.code >= 0) {
              utils.showMessage(res.msg)
              this.emailShow = false;
              this.emailSucceedShow = true;
              this.gitActivityInfo();
            } else {
              utils.showMessage(res.msg)
              this.emailShow = false;
            }
          })
        } else {
          utils.showMessage('请输入正确的邮箱格式')
        }
      },

      // 确认地址
      confirmLocation() {
        if (this.location) {
          this.$http({
            url: '/member/getNewPrize',
            method: 'post',
            params: {
              uid: Cookies.get('uid'),
              token: Cookies.get('token'),
              reg_channel: Cookies.get('reg_channel'),
              activity_reg_id: Cookies.get('aid'),
              type: this.wealNum,
              live_activity_id: this.$route.query.activityId,
              is_real: 1,
              to_user: this.userName,
              phone: this.userPhone,
              address: this.location,
            },
          }).then((res) => {
            if (res.code >= 0) {
              this.order = res.data.order_num;
              
              utils.showMessage(res.msg)
              this.locationShow = false;
              this.locationSucceedShow = true;
              this.gitActivityInfo();
            } else {
              utils.showMessage(res.msg)
              this.locationShow = false;
            }
          })
        } else {
          utils.showMessage('请输入您的详细地址')
        }
      },
      
      getOrder() {
        this.$http({
          url: '/member/getOrderNum',
          method: 'get',
          params: {
            uid: Cookies.get('uid'),
            token: Cookies.get('token'),
            reg_channel: Cookies.get('reg_channel'),
            activity_reg_id: Cookies.get('aid'),
            live_activity_id: this.$route.query.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.order = res.data.order_num;
          }
        })
      },
    }
  }
</script>

<style lang="css" scoped>
  .invite {
    position: relative;
    width: 100%;
    height: 348rem;
    background: linear-gradient(#0C4993, #160D49);
  }

  .informerBtn {
    position: absolute;
    top: 2rem;
    right: 0;
    display: flex;
    justify-content: flex-end;
  }

  .informerBtn p {
    width: 8rem;
    height: 2.5rem;
    background-color: rgba(255, 255, 255, 0.5);
    font-size: 1.4rem;
    color: #C9F7F7;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2.5rem 0 0 2.5rem;
  }

  .backInvite {
    width: 100%;
  }

  .inviteCon {
    width: 100%;
    box-sizing: border-box;
    padding: 0 1.1rem;
    position: absolute;
    top: 47.7rem;
    left: 0;
  }

  .swiperCon {
    width: 100%;
    height: 3.25rem;
    border-radius: 3.25rem;
    background: linear-gradient(rgba(126, 226, 255, 1), rgba(172, 255, 233, 0.19));
  }

  .swiperSlide {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.4rem;
    color: #FFFFFF;
    padding: 0 1.5rem;
  }

  .friendPhone {
    display: flex;
    align-items: center;
  }

  .phone {
    margin-left: .55rem;
  }

  .noPeople {
    box-sizing: border-box;
    width: 100%;
    height: 3.25rem;
    border-radius: 3.25rem;
    background: linear-gradient(rgba(126, 226, 255, 1), rgba(172, 255, 233, 0.19));
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1.5rem;
    font-size: 1.4rem;
    color: #FFFFFF;
  }
  
  .honoree {
    margin-top: 2.6rem;
    display: flex;
    align-items: center;
    background-size: 100% 100%;
    height: 4.2rem;
    padding-left: 3.55rem;
    color: #130756;
  }
  
  .honoree p {
    font-size: 1.5rem;
  }
  
  .honoree span {
    font-size: 1.95rem;
  }

  .wealNo1 {
    box-sizing: border-box;
    width: 100%;
    height: 43.5rem;
    background-size: 100% 100%;
    margin-top: 2rem;
    padding: 0 2rem;
  }

  .wealNum {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 6rem;
    padding-bottom: 1.3rem;
    font-size: 1.5rem;
    font-weight: 600;
    color: #00FFFF;
  }
  
  .wealNum img {
    height: .4rem;
    object-fit: cover;
    margin: 0 1rem;
  }
  
  .helpingNum {
    display: flex;
  }
  
  .residueNum {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .people {
    padding: 0 .5rem;
  }

  .wealCard {
    box-sizing: border-box;
  }

  .wealCon1 {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 1.4rem 0;
  }
  
  .wealCon1 div {
    display: flex;
    flex-direction: column;
  }

  .wealCon1 img {
    width: 4.4rem;
    height: 4.4rem;
    margin-right: 1rem;
  }

  .wealCon1 p:nth-child(1) {
    font-size: 1.4rem;
    font-weight: 600;
    color: #B2FFFF;
  }
  
  .wealCon1 p:nth-child(2) {
    font-size: 1.2rem;
    color: #C9F7F7;
  }
  
  .wealCon2 {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.4rem 0;
  }
  
  .wealCon2 div {
    display: flex;
    flex-direction: column;
  }
  
  .wealCon2 img {
    width: 4.4rem;
    height: 4.4rem;
  }
  
  .wealCon2 p:nth-child(1) {
    font-size: 1.4rem;
    font-weight: 600;
    color: #B2FFFF;
  }
  
  .wealCon2 p:nth-child(2) {
    font-size: 1.2rem;
    color: #C9F7F7;
  }

  .receiveAward {
    position: relative;
    display: flex;
    justify-content: center;
  }

  .receiveAward div {
    width: 20.8rem;
    height: 3.8rem;
    border-radius: 3.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 600;
    color: #8073C8;
    border: .1rem solid transparent;
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(130deg, #C0F7FF, #BBB1FF), linear-gradient(to right, #0E5FFF, #66FFFF, #0E5FFF);
  }
  
  .site div {
    color: #130756;
    background-image: linear-gradient(130deg, #80EEFF, #634DFD), linear-gradient(to right, #0E5FFF, #66FFFF, #0E5FFF);
  }
  
  .wealBtn {
    position: relative;
    display: flex;
    justify-content: center;
  }

  .wealBtn div {
    position: relative;
    width: 20.8rem;
    height: 3.8rem;
    border-radius: 3.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 600;
    color: #130756;
    border: .1rem solid transparent;
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(130deg, #80EEFF, #634DFD), linear-gradient(to right, #0E5FFF, #66FFFF, #0E5FFF);
  }

  .wealNo2 {
    box-sizing: border-box;
    width: 100%;
    height: 43.5rem;
    background-size: 100% 100%;
    margin-top: 1.95rem;
    padding: 0 2rem;
  }

  .wealNo3 {
    box-sizing: border-box;
    width: 100%;
    height: 51.65rem;
    background-size: 100% 100%;
    margin-top: 1.95rem;
    padding: 0 1.5rem;
  }
    
  .wealNo3 > .wealBtn {
    margin-top: 2rem;
  }

  .wealConCalendar {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
  }

  .wealConCalendar img {
    width: 25.5rem;
    margin-top: 1.2rem;
  }

  .wealConCalendar div {
    font-size: 1.4rem;
    color: #B2FFFF;
    text-align: center;
  }
  
  .wealConCalendar div span {
    font-size: 1rem;
  }
  
  .wealConPlacemat {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1.7rem;
    margin-bottom: 2rem
  }
  
  .wealConPlacemat img {
    height: 16rem;
    margin-top: .7rem;
  }
  
  .wealConPlacemat div {
    font-size: 1.4rem;
    color: #B2FFFF;
    text-align: center;
  }
  
  .wealConPlacemat div span {
    font-size: 1rem;
  }

  .inviteImg {
    width: 100%;
    margin-top: 2.35rem;
  }

  .conBtn {
    box-sizing: border-box;
    padding: 0 .9rem;
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }

  .liveStreamingBtn {
    position: relative;
    width: 13.5rem;
    height: 5.5rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;
    padding-bottom: .4rem;
    font-size: 1.45rem;
    font-weight: 600;
    color: #130555;
  }
  
  .liveStreamingBtn img {
    margin-top: .3rem;
    width: 1.85rem;
    margin-right: .4rem;
  }

  .giftBtn {
    position: relative;
    width: 17.6rem;
    height: 5.5rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-bottom: .4rem;
    font-size: 1.75rem;
    font-weight: 600;
    color: #130555;
  }

  .giftBtn img {
    width: 1.75rem;
    margin-right: .4rem;
  }
  
  .giftBtnType {
    transform: scale(1.1);
  }

  /* 邮件 */
  .emailCard {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .emailCon {
    width: 31rem;
    height: 35.8rem;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0 1.6rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .emailInput {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    border: none;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 2.5rem;
    font-size: 1.5rem;
    color: #642207;
    outline: none;
    margin-bottom: 2.8rem;
  }

  .emailInput[name="emailInput"]::-webkit-input-placeholder {
    color: #799CD3;
  }

  .confirmBtn {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    background: #FFFFFF;
    margin-bottom: 2.3rem;
    font-size: 1.8rem;
    font-weight: 600;
    color: #799CD3;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .emailSucceed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .emailSucceedCon {
    width: 31rem;
    height: 35.8rem;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0 1.6rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    text-align: center;
  }
  
  .emailSucceedTxt {
    font-size: 1.6rem;
    color: #FFFFFF;
    margin-bottom: 3rem;
  }
  
  .closeEmailSucceedBtn {
    width: 100%;
    height: 4.7rem;
    color: #130655;
    font-size: 1.8rem;
    background: linear-gradient(#FFE37D, #FFA74D);
    margin-bottom: 4.65rem;
    border-radius: 4.7rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }

  /* 地址 */
  .locationCard {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .locationCon {
    width: 31rem;
    height: 53rem;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0 1.6rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .locationTxt {
    margin-bottom: 1.5rem;
    width: 100%;
    height: 26rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    box-sizing: border-box;
    padding: 1.5rem 1.3rem;
  }

  .locationTxt p {
    text-align: center;
    font-size: 1.5rem;
    color: #150A5A;
    font-weight: 600;
  }
  
  .userName {
    box-sizing: border-box;
    border: .1rem solid #E9E9E9;
    outline: none;
    width: 100%;
    height: 3.8rem;
    margin-top: 1.5rem;
    border-radius: .5rem;
    padding: 0 1rem;
    color: #333333;
    font-size: 1.4rem;
  }
  
  .userName[name="userName"]::-webkit-input-placeholder {
    color: #91ADDA;
  }
  
  .userPhone {
    box-sizing: border-box;
    border: .1rem solid #E9E9E9;
    outline: none;
    width: 100%;
    height: 3.8rem;
    margin-top: 1rem;
    border-radius: .5rem;
    padding: 0 1rem;
    color: #333333;
    font-size: 1.4rem;
  }
  
  .userPhone[name="userPhone"]::-webkit-input-placeholder {
    color: #91ADDA;
  }
  
  .userLocation {
    box-sizing: border-box;
    border: .1rem solid #E9E9E9;
    border-radius: .5rem;
    padding: .8rem 1rem;
    color: #333333;
    font-size: 1.4rem;
    width: 100%;
    height: 9.55rem;
    margin-top: 1rem;
    font-family: -webkit-body;
    resize: none;
    outline: none;
  }
  
  .userLocation[name="userLocation"]::-webkit-input-placeholder {
    color: #91ADDA;
  }
  
  /* 地址填写成功 */
  .locationSucceed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .locationSucceedCon {
    width: 31rem;
    height: 35rem;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    text-align: center;
  }
  
  .locationSucceedTitle {
    font-size: 1.7rem;
    color: #FFFFFF;
    margin-bottom: 1.2rem;
  }
  
  .locationSucceedTxt {
    font-size: 1.6rem;
    color: #FFFFFF;
    margin-bottom: 2.3rem;
  }
  
  .locationSucceedBtn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 3rem;
  }
  
  .closeSucceedBtn {
    width: 13.5rem;
    height: 4.7rem;
    background: #FFFFFF;
    border-radius: 4.7rem;
    color: #150A5A;
    font-size: 1.8rem;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .openAppBtn {
    position: relative;
    width: 13.5rem;
    height: 4.7rem;
    background: linear-gradient(#FFE37D, #FFA74D);
    border-radius: 4.7rem;
    color: #150A5A;
    font-size: 1.8rem;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* 举报 */
  .informerHint {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .informerCon {
    width: 30rem;
    height: 19.3rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .informerInfo {
    font-size: 1.6rem;
    color: #1D2023;
  }

  .informerClose {
    width: 22.6rem;
    height: 4.4rem;
    background: linear-gradient(170deg, #FFCC76, #FF9A4D);
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4.4rem;
    color: #642207;
    font-size: 1.8rem;
    font-weight: 600;
  }
  
  /* 加群 */
  .addGroupHint {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  
  .groupCon {
    box-sizing: border-box;
    width: 31rem;
    height: 33rem;
    background-color: #FFFFFF;
    border-radius: .5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    padding: 0 1rem;
  }
  
  .groupCon div {
    font-size: 1.7rem;
    color: #333333;
    font-weight: 600;
  }
  
  .groupCon img {
    width: 17rem;
    height: 17rem;
    margin-top: 1.7rem;
    margin-bottom: 1rem;
  }
  
  .groupCon p {
    font-size: 1.4rem;
    color: #333333;
  }
  
  /* 打开app */
  .callApp {
    position: fixed;
    right: 0;
    bottom: 20rem;
    z-index: 9;
  }
  
  .callApp img {
    width: 9.55rem;
    height: 6.25rem;
  }
</style>
